export default __webpack_public_path__ + "static/media/session-menu.0e09081b.svg";